import type { ConfettiOptions } from 'tsparticles-confetti'
import { confetti } from 'tsparticles-confetti'

import type { EmojiName } from '@portal/news-lib/emoji'

export const fireConfetti = (params: { reaction: EmojiName; position: { x: number; y: number } }) => {
    const { reaction, position } = params

    const options: ConfettiOptions = {
        ...defaultConfettiOptions,
        ...getConfettiOptions(reaction),
        position: {
            x: (position.x / window.innerWidth) * 100,
            y: (position.y / window.innerHeight) * 100,
        },
    }

    return confetti(reaction, options)
}

const defaultConfettiOptions: ConfettiOptions = {
    count: 25,
    spread: 55,
    scalar: 1.6,
    // ticks: 100,
}

const partyPopperOptions: ConfettiOptions = {
    shapes: ['circle'],
}

const heartOptions: ConfettiOptions = {
    shapes: ['heart'],
    colors: ['#FFC0CB', '#FF69B4', '#FF1493', '#C71585'],
    scalar: 3.5,
    shapeOptions: {
        character: {
            value: ['❤️'],
        },
    },
}

const thumbsUpOptions: ConfettiOptions = {
    shapes: ['star'],
    scalar: 1.2,
    colors: ['FFE400', 'FFBD00', 'e87e00', 'ffef6c', 'fff9b2'],
    shapeOptions: {
        character: {
            value: ['👍'],
        },
    },
}

const grinnyFaceOptions: ConfettiOptions = {
    shapes: ['character', 'circle', 'star', 'square'],
    colors: ['3cff3c', '9dff55', 'd7ff81', '19f677', '03d785'],
    shapeOptions: {
        character: {
            value: ['😆'],
        },
    },
}

const openMouthOptions: ConfettiOptions = {
    shapes: ['character', 'square'],
    scalar: 2.0,
    colors: ['00eaf3', '00cff4', '009ad3'],
    shapeOptions: {
        character: {
            value: ['😮'],
        },
    },
}

const getConfettiOptions = (emojiName: EmojiName) => {
    switch (emojiName) {
        case 'party_popper':
            return partyPopperOptions
        case 'thumbs_up':
            return thumbsUpOptions
        case 'grinning_squinting_face':
            return grinnyFaceOptions
        case 'face_with_open_mouth':
            return openMouthOptions
        case 'sparkling_heart':
            return heartOptions
    }
}
